<template>
  <b-modal
    id="modal-edit-kategori"
    v-model="isVisible"
    hide-footer
    hide-header
    hide-header-close
    no-close-on-esc
    centered
    @hidden="onHidden"
  >
    <div class="flex items-center justify-between mb-[24px] mt-[12px]">
      <span class="font-semibold text-[18px] text-[#333333]">Edit Kategori</span>
      <b-button
        variant="ghost"
        class="!p-0 !text-[32px] text-[#292D32] rotate-45"
        @click="onCancel"
      >
        <span class="k-add" />
      </b-button>
    </div>
    <b-form @submit.prevent="onSubmit">
      <b-form-group class="mb-[24px]">
        <label class="font-medium text-[14px] text-[#333333] mb-[6px] block">
          Nama Kategori<span class="text-[#F95031]">*</span>
        </label>
        <b-form-input
          v-model="form.nama"
          placeholder="Masukkan nama kategori"
          maxlength="30"
          class="!rounded-[8px]"
        />
        <div class="flex items-center justify-between mt-[4px] mb-[12px]">
          <span
            class="flex items-center gap-[4px] text-[12px]"
            :class="showUniqueError ? 'text-[#F95031]' : 'text-[#828282]'"
          >
            <span class="k-danger text-[14px]" />
            {{ showUniqueError ? 'Nama kategori sudah digunakan.' : 'Nama kategori harus unik' }}
          </span>
          <span class="text-[12px] text-[#626262]">{{ form.nama.length }}/30</span>
        </div>
      </b-form-group>

      <div class="flex gap-[12px] mt-[8px] mb-[12px]">
        <b-button
          variant="outline-secondary"
          class="flex-1 !rounded-[8px]"
          @click="onCancel"
        >
          Batal
        </b-button>
        <b-button
          type="submit"
          variant="primary"
          class="flex-1 !rounded-[8px] btn-simpan"
          :disabled="!isFormValid || isLoading"
          @click.prevent="onSubmit"
        >
          <b-spinner
            v-if="isLoading"
            small
            class="mr-1"
          />
          Simpan
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalEditKategori',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    categoryData: {
      type: Object,
      default: () => null,
    },
    existingNames: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
      form: {
        nama: '',
      },
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    isChanged() {
      const currentName = (this.categoryData?.name || '').trim()
      const newName = this.form.nama.trim()
      return newName !== currentName
    },
    isDuplicate() {
      const trimmed = this.form.nama.trim().toLowerCase()
      const currentName = (this.categoryData?.name || '').trim().toLowerCase()
      if (trimmed === currentName) return false
      return this.existingNames.some(n => n.toLowerCase() === trimmed)
    },
    showUniqueError() {
      return this.form.nama.trim().length > 0 && this.isDuplicate
    },
    isFormValid() {
      return this.form.nama.trim().length > 0 && !this.isDuplicate && this.isChanged
    },
  },
  watch: {
    categoryData: {
      immediate: true,
      handler(val) {
        if (val && val.name) {
          this.form.nama = val.name
        }
      },
    },
    value(val) {
      if (val && this.categoryData && this.categoryData.name) {
        this.form.nama = this.categoryData.name
      }
    },
  },
  methods: {
    async onSubmit() {
      if (!this.isFormValid || this.isLoading || !this.categoryData?.id) return
      const label = this.form.nama.trim()
      const value = label.toLowerCase().replace(/\s+/g, '_')
      this.isLoading = true
      try {
        await this.$http_new.put(`/komclass/api/v1/komlabs/campaigns/options/${this.categoryData.id}`, {
          option_label: label,
          option_value: value,
        })
        if (this.$toast_success) {
          this.$toast_success({ message: 'Kategori berhasil diperbarui.' })
        }
        this.$emit('success')
        this.isVisible = false
      } catch (error) {
        if (this.$toast_error) {
          this.$toast_error({ message: 'Gagal memperbarui kategori.' })
        }
      } finally {
        this.isLoading = false
      }
    },
    onCancel() {
      this.isVisible = false
    },
    onHidden() {
      this.form.nama = ''
    },
  },
}
</script>

<style scoped>
:deep(.btn-simpan:disabled),
:deep(.btn-simpan.disabled) {
  background-color: #F95031 !important;
  border-color: #F95031 !important;
  opacity: 0.5;
}
</style>
